/* LYVN Diwali homepage: night sky, gold second line on headings, footer touches */
(function () {
  if (window.__dwHome) return;
  window.__dwHome = true;
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* 1. fixed night sky with twinkling stars and rising lanterns */
  function sky() {
    if (document.querySelector('.dw-gsky')) return;
    var el = document.createElement('div');
    el.className = 'dw-gsky'; el.setAttribute('aria-hidden', 'true');
    var html = '';
    for (var i = 0; i < 70; i++) {
      html += '<i class="dw-star" style="left:' + (Math.random() * 100).toFixed(2) + '%;top:' + (Math.random() * 100).toFixed(2) + '%;animation-delay:' + (Math.random() * 3).toFixed(2) + 's"></i>';
    }
    if (!reduce) {
      for (var j = 0; j < 8; j++) {
        html += '<i class="dw-lantern" style="left:' + (5 + Math.random() * 90).toFixed(2) + '%;animation-duration:' + (16 + Math.random() * 14).toFixed(1) + 's;animation-delay:-' + (Math.random() * 25).toFixed(1) + 's"></i>';
      }
    }
    el.innerHTML = html;
    document.body.insertBefore(el, document.body.firstChild);
  }

  /* 2. headings: second part in gold italic, like the design
        "Built for everyday. Styled for every diya."  -> second sentence on its own line
        "LYVN Trends & Bestsellers"                    -> "& Bestsellers"
        "Everyday Essentials, Elevated"                -> "Elevated"
        "Best seller of the month"                     -> "of the month"
        "Light up\nyour style"                         -> line after the line break */
  function splitHeading(h) {
    if (!h || h.__dw) return;
    h.__dw = true;
    var br = h.querySelector('br');
    if (br) {
      var span = document.createElement('em'); span.className = 'dw-em';
      while (br.nextSibling) span.appendChild(br.nextSibling);
      h.appendChild(span);
      return;
    }
    if (h.children.length) return;
    var t = h.textContent.replace(/\s+/g, ' ').trim(), a, b, block = false, m;
    if ((m = t.indexOf('. ')) > 0 && m < t.length - 2) { a = t.slice(0, m + 1); b = t.slice(m + 2); block = true; }
    else if ((m = t.indexOf(' — ')) > 0) { a = t.slice(0, m + 2); b = t.slice(m + 3); }
    else if ((m = t.indexOf(' & ')) > 0) { a = t.slice(0, m); b = t.slice(m + 1); }
    else if ((m = t.lastIndexOf(', ')) > 0) { a = t.slice(0, m + 1); b = t.slice(m + 2); }
    else if ((m = t.toLowerCase().indexOf(' of the ')) > 0) { a = t.slice(0, m); b = t.slice(m + 1); }
    else return;
    h.textContent = a + ' ';
    var em = document.createElement('span');
    em.className = 'dw-em' + (block ? ' dw-em--block' : '');
    em.textContent = b;
    h.appendChild(em);
  }
  function headings() {
    document.querySelectorAll(
      '.section-header h2, .rich-text h3, .best-seller-month__title, .image-with-text-overlay--heading, .home-scroll-video__heading'
    ).forEach(splitHeading);
  }

  /* 3. footer: Hindi greeting + big faded LYVN */
  function footer() {
    var f = document.querySelector('.footer');
    if (!f || f.querySelector('.dw-footer-big')) return;
    var hi = document.createElement('p'); hi.className = 'dw-footer-hi';
    hi.textContent = 'Happy Diwali from Team LYVN';
    /* big faded brand logo: uses the same logo image as the header (falls back to text) */
    var big = document.createElement('div'); big.className = 'dw-footer-big'; big.setAttribute('aria-hidden', 'true');
    var logo = document.querySelector('.header .logolink img.logoimg:not(.logoimg--light)') || document.querySelector('.header .logolink img');
    if (logo) {
      var img = new Image();
      img.src = logo.currentSrc || logo.src;
      img.alt = ''; img.loading = 'lazy'; img.className = 'dw-footer-logo';
      big.appendChild(img);
    } else {
      big.textContent = 'LYVN';
    }
    f.appendChild(hi); f.appendChild(big);
  }

  /* 4. "In the press" pills: when no logo image is uploaded, show an icon + label instead of the grey placeholder */
  var PRESS = [
    ['Made in India', '<path d="M12 2l2.4 4.9 5.4.8-3.9 3.8.9 5.4L12 14.3 7.2 16.9l.9-5.4L4.2 7.7l5.4-.8z"/><path d="M6 21h12"/>'],
    ['Fabric First', '<path d="M8 3 4 6l2 4 2-1v12h8V9l2 1 2-4-4-3c-.5 1.7-2 3-4 3S8.5 4.7 8 3z"/>'],
    ['Quality Checked', '<circle cx="11" cy="11" r="7"/><path d="m8 11 2 2 4-4M16 16l5 5"/>'],
    ['Loved by 50,000+', '<path d="M12 20s-7-4.4-7-10a4 4 0 0 1 7-2.6A4 4 0 0 1 19 10c0 5.6-7 10-7 10z"/>']
  ];
  function pressDots() {
    document.querySelectorAll('.testimonials .dot-style--logos .dot').forEach(function (dot, i) {
      if (dot.__dw || dot.querySelector('img')) return;
      dot.__dw = true;
      var d = PRESS[i % PRESS.length];
      dot.classList.add('dw-press-dot');
      dot.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">' + d[1] + '</svg><span>' + d[0] + '</span>';
    });
  }

  /* 5. banner: give the section the real shape of its (visible) image so nothing is cropped */
  function bannerRatio() {
    document.querySelectorAll('.image-with-text-overlay').forEach(function (sec) {
      var imgs = sec.querySelectorAll('.image-with-text-overlay--bg img');
      var img = null;
      imgs.forEach(function (i) { if (i.offsetParent !== null || getComputedStyle(i).display !== 'none') { if (!img && i.getClientRects().length) img = i; } });
      img = img || imgs[0];
      if (!img) return;
      function apply() {
        var w = img.naturalWidth || +img.getAttribute('width'), h = img.naturalHeight || +img.getAttribute('height');
        if (!w || !h) return;
        sec.style.setProperty('--dw-ar', w + ' / ' + h);
        sec.classList.add('dw-ar');
      }
      apply(); if (!img.complete) img.addEventListener('load', apply, { once: true });
    });
  }
  var rT; window.addEventListener('resize', function () { clearTimeout(rT); rT = setTimeout(bannerRatio, 200); });

  function run() { sky(); headings(); footer(); pressDots(); bannerRatio(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  window.addEventListener('load', headings);
})();